import { render, staticRenderFns } from "./Personnel.vue?vue&type=template&id=99878f7e&scoped=true&"
import script from "./Personnel.vue?vue&type=script&lang=js&"
export * from "./Personnel.vue?vue&type=script&lang=js&"
import style0 from "./Personnel.vue?vue&type=style&index=0&id=99878f7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99878f7e",
  null
  
)

export default component.exports